/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import Link from 'next/link';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';

/**
 * Renders the   ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * 
 * @returns {ReactElement} ImageBannerAd component
 */
const ContactUs = ({
    section, region, language
}) => {
    return (
        <Box
            margin={{
                base: "0px 0px 30px  0",
                sm: "0px 0px 30px  0",
                lg: "0px 0px 30px  0",
            }}
            display={"flex"}
            flexDirection={{ base: "column", sm: "column", lg: "row" }}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                borderRight={{
                    base: "0px", sm: "0px", lg: "1px solid black"
                }}
                pr={{ base: 0, sm: 0, lg: "42px" }}
            >
                <Box
                    fontFamily={"FedraSansStd-book"}
                    fontWeight={"bold"}
                    fontSize={{ base: "24px", sm: "24px", lg: "30px" }}
                    color={"#000000"}
                >
                    {section[0]?.titleText}
                </Box>
            </Box>

            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={{ base: "center", sm: "center", lg: "start" }}
                alignItems={{ base: "center", sm: "center", lg: "start" }}
                marginTop={{ base: "5px", sm: "5px", lg: "0" }}
                marginLeft={{
                    base: "0px", sm: "0px", lg: "40px"
                }}
                fontFamily={"FedraSansStd-book"}
                fontSize={{base:'18px', md:'24px'}}
                textAlign={'center'}
            >
                {StructuredTextContent(section[1].body)}
            </Box>
        </Box >
    );
};

export default ContactUs;
